import { BrowserRouter, Routes, Route } from "react-router-dom";
import {
  Navbar,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink
} from 'reactstrap';

import MainBody    from './components/MainBody'
import MfcCarousel from './components/MfcCarousel'
import MfcManual   from './components/MfcManual'
import MfcBuy      from './components/MfcBuy'
// import MfcDownload      from './components/MfcDownload'

import './App.css';
import mfClogoicon from './img/brand/mf_change_logo_flat_rounded_corners.png'

function MFCNav() {
  let test_warning = "";
  if (process.env.REACT_APP_STRIPE_API_KEY.startsWith('pk_test') ) { 
    test_warning = " -test mode";
  };
  return (
    <div>
      <Navbar role="navigation" color="dark" dark expand="md" fixed="top">
        <NavbarBrand href="/">
          <img src={mfClogoicon} alt='' style={{width:'30px',height:'30px'}}/>
          &nbsp;mfChangeNote{test_warning}
        </NavbarBrand>
        <Nav className="ml-auto" navbar>
          <NavItem>
            <NavLink href="/#">Home</NavLink>
          </NavItem>
          <NavItem>
            <NavLink href="/#about">About</NavLink>
          </NavItem>
          <NavItem>
            <NavLink href="/#contact">Contact</NavLink>
          </NavItem>
          <NavItem>
            <NavLink href="/buy">Buy</NavLink>
          </NavItem>
          <NavItem>
            <NavLink href="/manual">Using mfChangeNote</NavLink>
          </NavItem>
        </Nav>
      </Navbar>
    </div>
  );
}

const MainPage = () => 
<div style={{ paddingTop: '40px', marginBottom:'-16px' }}>
  <MfcCarousel />
  <MainBody />
</div>;
const BuyPage = () => 
<div style={{ paddingTop: '20px', marginBottom:'-16px' }}>
  <MfcBuy/>
</div>;
const ManualPage = () => 
<div style={{ paddingTop: '60px' }}>
  <MfcManual/>
</div>;
// const DownloadPage = () => 
//   <div style={{ paddingTop: '60px' }}>
//     <MfcDownload/>
//   </div>;

export default function App() {
  return (
    //NOTE:when serving this app, the server must have a way to return page routes to the "index.html"
    //page, probably by sending that page back from all 404 Not Found errors, or by explicitly
    //handling the "buy","manual" and "download" page routes
    <BrowserRouter>
      <div className="App">
        <header className="App-header">
          <MFCNav />
        </header>
        <main>
          <Routes>
            <Route index element={<MainPage />} />
            <Route path="/index.html" element={<MainPage />} /> 
            <Route path="/buy" element={<BuyPage /> } />
            <Route path="/manual" element={<ManualPage />} />
            {/* <Route path="/download" element={<DownloadPage />} /> */}
          </Routes>
        </main>
        <footer className="App-footer">
          <p><small>&copy;the website and the program, by me 2025</small></p>
        </footer>
      </div>
      </BrowserRouter>
  );
}